<!--
 * @Description: 潜在客户信息
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-05-29 09:30:49
 * @LastEditors: cxh
-->
<template>
  <a-form ref="formRef" name="advanced_search" :model="form">
    <dc-layout-card title="基本信息">
      <dc-form-item
        :name="['customerInfo', 'customerName']"
        label="客户名称"
        :rules="{
          message: '请输入',
          required: true
        }"
      >
        <CosInputTianyancha
          v-model:value="form.customerInfo.customerName"
          :maxlength="50"
          placeholder="请输入"
          appId="cos_fbu"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        label="主客户代码"
        :name="['customerInfo', 'customerNumber']"
        :rules="
          perfect && type !== 'potential'
            ? {
                message: '请选择',
                required: true
              }
            : []
        "
      >
        <SerialSelect
          v-model:value="form.customerInfo.customerNumber"
          :cosId="route.query.cosId"
          :view="formItemView"
          :requiredCosId="true"
          :disabled="!formItemView && !permissionBtn.includes(permissionPage.editCode) ? true : false"
        />
      </dc-form-item>
      <dc-form-item
        label="客户状态"
        :name="['customerInfo', 'status']"
        :rules="{
          message: '请选择',
          validator: selectForNumberValidate,
          required: true
        }"
      >
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <div v-for="item in status" :key="item.value">
                <p>{{ item.label }}{{ item.desc ? `：${item.desc}` : '' }}</p>
              </div>
            </template>
            <span>客户状态</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosSelect
          v-model:value="form.customerInfo.status"
          allowClear
          placeholder="请选择"
          :disabled="disabled || type === 'clients'"
          :options="status"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        label="客户类型"
        :name="['customerInfo', 'type']"
        :rules="{
          message: '请选择',
          validator: selectForNumberValidate,
          required: true
        }"
      >
        <CosSelect
          v-model:value="form.customerInfo.type"
          :options="customerTypeEnum"
          placeholder="请选择"
          allow-clear
          :view="formItemView"
        />
      </dc-form-item>
      <!--成交客户：档次和评级--->
      <template v-if="formItemView && type === 'clients'">
        <dc-form-item label="档次">
          <CosInput v-model:value="form.customerInfo.level" :view="formItemView" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="成交金额（万）">
          <CosInput v-model:value="form.customerInfo.turnoverAmount" :view="formItemView" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="客户评级">
          <CosSelect
            v-model:value="form.customerInfo.grade"
            :options="customerGradeEnum"
            :view="formItemView"
            placeholder="请选择"
          />
        </dc-form-item>
      </template>
      <dc-form-item
        label="线索来源"
        :name="['customerInfo', 'channel']"
        :rules="{
          required: true,
          message: '请选择'
        }"
      >
        <a-input-group compact class="cos-view-input-group">
          <ParamCodeCascader
            v-model:value="form.customerInfo.channel"
            appId="cos_fbu"
            paramCode="fbu_source_channel"
            :status="formItemView ? undefined : 0"
            :disabled="disabled"
            style="width: 33%"
            :view="formItemView"
            :cosDes="form.customerInfo.channelExplain"
          />
          <CosInput
            v-model:value="form.customerInfo.channelExplain"
            placeholder="请输入"
            style="width: 67%"
            :view="formItemView"
          />
        </a-input-group>
      </dc-form-item>
      <dc-form-item
        label="客户办公地"
        :name="['customerInfo', 'customerOffice']"
        :rules="{
          message: '请选择',
          required: true
        }"
      >
        <customer-area v-model:value="form.customerInfo.customerOffice" :view="formItemView" change-on-select />
      </dc-form-item>
      <dc-form-item
        label="客户详细地址"
        :name="['customerInfo', 'customerAddress']"
        :rules="{
          message: '请输入',
          required: true
        }"
      >
        <!-- <MapModal
          v-model:address="form.customerInfo.customerAddress"
          v-model:geoPoint="form.customerInfo.geoPoint"
          :view="formItemView"
        ></MapModal> -->
        <CosInput
          v-model:value="form.customerInfo.customerAddress"
          :maxlength="200"
          placeholder="请输入"
          :disabled="disabled"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item label="工厂详细地址">
        <CosInput
          v-model:value="form.customerInfo.factoryAddress"
          :maxlength="200"
          placeholder="请输入"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item label="客户规模">
        <ParamCodesSelect
          :options="paramCodeData.fbu_customer_size"
          v-model:value="form.customerInfo.enterpriseScale"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item label="关联市场活动">
        <ParamCodesSelect
          :options="paramCodeData.fbu_marketing_activity"
          v-model:value="form.customerInfo.activityId"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item :name="['customerInfo', 'listedFlag']" label="是否上市">
        <CosRadioGroup v-model:value="form.customerInfo.listedFlag" :options="flagEnum" :view="formItemView" />
      </dc-form-item>
      <dc-form-item
        label="是否内部客户"
        :name="['customerInfo', 'internalCustomersFlag']"
        :rules="{
          message: '请选择',
          required: true
        }"
      >
        <CosRadioGroup
          v-model:value="form.customerInfo.internalCustomersFlag"
          :options="flagEnum"
          :view="formItemView"
        />
      </dc-form-item>
      <template v-if="formItemView">
        <dc-form-item label="剩余跟进天数">
          <CosInput v-model:value="form.customerInfo.remanentFollowDays" :view="formItemView" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="跟进人">
          <CosInput v-model:value="form.customerInfo.sellerName" :view="formItemView" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="创建人">
          <CosInput v-model:value="form.customerInfo.createByName" :view="formItemView" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="客户ID">
          <CosInput v-model:value="form.customerInfo.cosId" :view="formItemView" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="转为签约时间" v-if="form.customerInfo.status > 19">
          <CosInput v-model:value="form.customerInfo.turnedContract" :view="formItemView" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="转为成交时间" v-if="form.customerInfo.status > 29">
          <CosInput v-model:value="form.customerInfo.turnedTransaction" :view="formItemView" placeholder="请输入" />
        </dc-form-item>
      </template>
      <template v-if="formItemView">
        <dc-form-item label="创建时间">
          <CosInput v-model:value="form.customerInfo.createTime" :view="formItemView" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="最后领取时间">
          <CosInput v-model:value="form.customerInfo.lastReceiveTime" :view="formItemView" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="转潜在时间">
          <CosInput
            v-model:value="form.customerInfo.turnedPotential"
            :view="formItemView"
            placeholder="请输入"
          /> </dc-form-item
      ></template>
      <a-col :span="24" />
      <dc-form-item label="备注" :span="12">
        <CosTextarea
          v-model:value="form.customerInfo.remark"
          :maxlength="2000"
          placeholder="请输入"
          :view="formItemView"
        />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card title="联系人信息">
      <dc-form-item
        :name="['contact', 'contactType']"
        label="联系人类型"
        :rules="{
          message: '请选择',
          validator: selectForNumberValidate,
          required: true
        }"
      >
        <CosSelect
          v-model:value="form.contact.contactType"
          :options="contactTypeEnum"
          placeholder="请选择"
          :view="formItemView"
          allowClear
        />
      </dc-form-item>
      <dc-form-item
        label="联系人姓名"
        :name="['contact', 'name']"
        :rules="[
          {
            message: '请输入',
            required: true
          },
          {
            validator: concatNameValidate
          }
        ]"
      >
        <CosInput v-model:value="form.contact.name" :view="formItemView" placeholder="请输入" :maxlength="50" />
      </dc-form-item>
      <dc-form-item label="手机号" class="form-item_compact">
        <a-input-group compact class="cos-view-input-group">
          <ParamCodesSelect
            :options="paramCodeData.fbu_area_code"
            v-model:value="form.contact.mobileRegion"
            :view="formItemView"
            :cosDes="form.contact.mobile"
            style="width: 33%"
          />
          <dc-form-item
            :span="24"
            style="width: 67%"
            class="last-compact"
            :name="['contact', 'mobile']"
            :rules="{
              validator: (rule, value) => contactValidate(rule, value, form.contact, formRef)
            }"
          >
            <CosInput v-model:value="form.contact.mobile" :view="formItemView" placeholder="请输入" />
          </dc-form-item>
        </a-input-group>
      </dc-form-item>
      <dc-form-item
        :name="['contact', 'wechat']"
        label="微信号"
        :rules="{
          validator: (rule, value) => contactValidate(rule, value, form.contact, formRef)
        }"
      >
        <CosInput v-model:value="form.contact.wechat" :view="formItemView" placeholder="请输入" />
      </dc-form-item>
      <dc-form-item
        :name="['contact', 'qq']"
        label="QQ号"
        :rules="{
          validator: (rule, value) => contactValidate(rule, value, form.contact, formRef)
        }"
      >
        <CosInput v-model:value="form.contact.qq" :view="formItemView" placeholder="请输入" />
      </dc-form-item>
      <dc-form-item
        :name="['contact', 'email']"
        label="邮箱"
        :rules="[
          {
            validator: (rule, value) => contactValidate(rule, value, form.contact, formRef)
          }
        ]"
      >
        <CosInput v-model:value="form.contact.email" :view="formItemView" placeholder="请输入" />
      </dc-form-item>
      <dc-form-item label="固定电话" class="form-item_compact">
        <a-input-group compact class="cos-view-input-group">
          <ParamCodesSelect
            :options="paramCodeData.fbu_area_code"
            v-model:value="form.contact.telRegion"
            :cosDes="form.contact.tel"
            :view="formItemView"
            style="width: 33%"
          />
          <dc-form-item
            :span="24"
            style="width: 67%"
            class="last-compact"
            :name="['contact', 'tel']"
            :rules="{
              validator: (rule, value) => contactValidate(rule, value, form.contact, formRef),
              trigger: 'blur'
            }"
          >
            <CosInput v-model:value="form.contact.tel" :view="formItemView" placeholder="请输入" />
          </dc-form-item>
        </a-input-group>
      </dc-form-item>
      <dc-form-item label="角色">
        <CosSelect
          v-model:value="form.contact.jobRole"
          :options="linkRoleTypeEnum"
          placeholder="请选择"
          allow-clear
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item label="部门职务">
        <CosInput v-model:value="form.contact.jobDuty" :view="formItemView" placeholder="请输入" :maxlength="50" />
      </dc-form-item>
      <dc-form-item label="传真号">
        <CosInput v-model:value="form.contact.fax" :view="formItemView" placeholder="请输入" :maxlength="50" />
      </dc-form-item>
      <dc-form-item label="性别">
        <CosRadioGroup v-model:value="form.contact.sex" :view="formItemView" :options="genderEnum" />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item label="联系人备注" :span="12">
        <CosTextarea v-model:value="form.contact.remark" :maxlength="2000" placeholder="请输入" :view="formItemView" />
      </dc-form-item>
      <a-col :span="6" />
    </dc-layout-card>
    <dc-layout-card title="签到地址（添加后才能签到打卡）" :span="6">
      <template #title>
        <div style="display: flex; align-items: center; height: 24px; margin-bottom: 13px">
          <div class="dc-card-header-defaut-line"></div>
          <p style="font-size: 16px; font-weight: 500">签到地址</p>
          <span style="color: #999; font-size: 12px">（添加后才能签到打卡）</span>
          <div style="flex: 1 1 0%; text-align: right">
            <a-button type="primary" ghost @click="handleAddressAdd(form.visitAddress)" v-if="!disabled">新增</a-button>
          </div>
        </div>
      </template>
      <MultipleItem :view="formItemView" :line="false">
        <template v-for="(item, index) in form.visitAddress" :key="index">
          <dc-form-item
            :label="index ? '' : '签到地址'"
            :class="index ? 'no-form-label' : ''"
            :name="['visitAddress', index, 'addressName']"
            :rules="[
            { validator: (rule:any, value:number) => checkAddressValidate(rule, value, form.visitAddress, 'addressTag', '请选择') }
          ]"
          >
            <MapModal
              v-model:address="item.addressName"
              v-model:geoPoint="item.geoPoint"
              :view="formItemView"
            ></MapModal>
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '地址类型'"
            :class="index ? 'no-form-label' : ''"
            :name="['visitAddress', index, 'addressTag']"
            :rules="[
            { validator: (rule:any, value:number) => checkAddressValidate(rule, value, form.visitAddress, 'addressName', '请输入') }
          ]"
          >
            <div class="flex">
              <ParamCodesSelect
                :options="paramCodeData.fbu_sign_in_address_label"
                v-model:value="item.addressTag"
                :disabled="disabled"
                :view="formItemView"
                allowClear
                style="width: 100%"
              />
              <a-button
                type="text"
                danger
                style="padding: 0 0 0 12px"
                v-if="!disabled && form.visitAddress && form.visitAddress.length > 1"
                @click="handleAddressAddDel(index, form.visitAddress)"
                >删除</a-button
              >
              <a-checkbox style="padding: 3px 0 0 12px; width: 150px;" :disabled="disabled" :checked="item.mainAddressFlag === 1" @change="clearMainAddressFlag(index)">主要</a-checkbox>
            </div>
          </dc-form-item>
          <a-col :span="12" />
        </template>
      </MultipleItem>
    </dc-layout-card>
    <dc-layout-card title="客户业务情况">
      <template #subTitle>
        <a-button type="primary" v-if="!disabled" ghost @click="handleAddCol(form.business.saleInfo)">新增</a-button>
      </template>
      <dc-form-item
        label="客户业务类型"
        :name="['business', 'businessType']"
        :rules="
          perfect
            ? {
                message: '请选择',
                type: 'array',
                required: true
              }
            : []
        "
      >
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.fbu_business_type"
          v-model:value="form.business.businessType"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        label="年销售GMV(万)"
        :name="['business', 'annualSales']"
        :rules="{
          message: '请输入',
          required: true
        }"
      >
        <CosInputNumber
          v-model:value="form.business.annualSales"
          style="width: 100%"
          :maxlength="15"
          :min="0"
          placeholder="请输入"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        label="销售品类"
        :name="['business', 'salesCategory']"
        :rules="
          perfect
            ? {
                message: '请选择',
                required: true
              }
            : []
        "
      >
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.fbu_sales_category"
          v-model:value="form.business.salesCategory"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        label="货物类型"
        :name="['business', 'cargoType']"
        :rules="
          perfect
            ? {
                message: '请选择',
                required: true
              }
            : []
        "
      >
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.fbu_product_type"
          v-model:value="form.business.cargoType"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        label="合作海外仓"
        :name="['business', 'warehouse']"
        :rules="
          perfect
            ? {
                message: '请选择',
                required: true
              }
            : []
        "
      >
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.fbu_warehouse"
          v-model:value="form.business.warehouse"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        label="客户类别"
        :name="['business', 'customerCategory']"
        :rules="
          {
                message: '请选择',
                required: true
              }
        "
      >
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.fbu_customer_category"
          v-model:value="form.business.customerCategory"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        label="是否供货商"
        :name="['business', 'supplierFlag']"
        :rules="
          perfect
            ? {
                message: '请选择',
                required: true
              }
            : []
        "
      >
        <CosRadioGroup v-model:value="form.business.supplierFlag" :options="flagEnum" :view="formItemView" />
      </dc-form-item>
      <dc-form-item
        label="需要金融产品"
        :name="['business', 'financialProductFlag']"
        :rules="
          perfect
            ? {
                message: '请选择',
                required: true
              }
            : []
        "
      >
        <CosRadioGroup v-model:value="form.business.financialProductFlag" :options="flagEnum" :view="formItemView" />
      </dc-form-item>
      <dc-form-item
        label="是否分销商"
        :name="['business', 'dealerFlag']"
        :rules="
          perfect
            ? {
                message: '请选择',
                required: true
              }
            : []
        "
      >
        <CosRadioGroup v-model:value="form.business.dealerFlag" :options="flagEnum" :view="formItemView" />
      </dc-form-item>
      <dc-form-item
        label="是否产业带"
        :name="['business', 'industrialBeltFlag']"
        :rules="{
          message: '请选择',
          required: true
        }"
      >
        <CosRadioGroup
          v-model:value="form.business.industrialBeltFlag"
          :options="flagEnum"
          :view="formItemView"
          @change="changeIndustrialBeltFlag"
        />
      </dc-form-item>
      <dc-form-item
        label="产业带"
        :name="['business', 'industrialBelt']"
        :rules="{
          message: '请选择',
          validator: selectForNumberValidate,
          required: true
        }"
        v-if="form.business.industrialBeltFlag === 1"
      >
        <ParamCodesSelect
          :options="paramCodeData.fbu_industrial_belt"
          v-model:value="form.business.industrialBelt"
          v-model:label="form.business.industrialBeltLabel"
          @change="changeIndustrialBeltLabel"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        label="产业带名称"
        :name="['business', 'industrialBeltName']"
        v-if="form.business.industrialBelt && form.business.industrialBeltLabel === '其他'"
        :rules="{
          message: '请输入',
          required: true
        }"
      >
        <CosInput
          v-model:value="form.business.industrialBeltName"
          :maxlength="100"
          placeholder="请输入"
          :view="formItemView"
        />
      </dc-form-item>
      <MultipleItem :view="formItemView">
        <template v-for="(item, index) in form.business.saleInfo" :key="`saleInfo${index}`">
          <dc-form-item
            :label="index ? '' : '在售电商平台'"
            :span="6"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'saleInfo', index, 'salePlatformId']"
            :rules="
              perfect
                ? {
                    message: '请选择',
                    validator: selectForNumberValidate,
                    required: true
                  }
                : {
                    message: '请选择',
                    validator: (rule, value) =>
                      arrayValueValidate(rule, value, {
                        salePlatformId: item.salePlatformId,
                        percent: item.percent
                      })
                  }
            "
          >
            <ParamCodesSelect
              :options="paramCodeData.fbu_sale_platform"
              v-model:value="item.salePlatformId"
              :view="formItemView"
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '在售平台占比(%)'"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'saleInfo', index, 'percent']"
            :span="6"
            :rules="
              perfect
                ? [
                    {
                      message: '请输入',
                      required: true
                    },
                    {
                      validator: percentValidate
                    }
                  ]
                : [
                    {
                      validator: percentValidate
                    },
                    {
                      message: '请输入',
                      validator: (rule, value) =>
                        arrayValueValidate(rule, value, {
                          salePlatformId: item.salePlatformId,
                          percent: item.percent
                        })
                    }
                  ]
            "
          >
            <div class="flex">
              <CosInputNumber
                v-model:value="item.percent"
                style="width: 100%"
                :maxlength="15"
                :min="0"
                placeholder="请输入"
                :view="formItemView"
              />
              <a-button
                type="text"
                v-if="form.business.saleInfo && form.business.saleInfo.length > 1 && !disabled"
                @click="handleDelCol(form.business.saleInfo, index)"
                danger
                style="padding: 0 0 0 12px"
                >删除</a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="24"></a-col>
        </template>
      </MultipleItem>
    </dc-layout-card>
    <dc-layout-card title="需求海外仓">
      <template #subTitle>
        <a-button type="primary" v-if="!disabled" ghost @click="handleAddCol(form.business.demandInfo.warehouses)"
          >新增</a-button
        >
      </template>
      <dc-form-item
        label="服务需求"
        :span="6"
        :name="['business', 'demandInfo', 'demandIds']"
        :rules="
          perfect
            ? {
                message: '请选择',
                required: true
              }
            : []
        "
      >
        <ParamCodesSelect
          :options="paramCodeData.fbu_service_demand"
          v-model:value="form.business.demandInfo.demandIds"
          mode="multiple"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item label="海外仓月消费总额（万元）" :span="6">
        <CosInput :value="amount" placeholder="请输入" :disabled="true" :view="formItemView" />
      </dc-form-item>
      <MultipleItem :view="formItemView">
        <template v-for="(item, index) in form.business.demandInfo.warehouses" :key="`demandInfo${index}`">
          <dc-form-item
            :label="index ? '' : '需求海外仓'"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'demandInfo', 'warehouses', index, 'warehouseId']"
            :rules="
              perfect
                ? {
                    message: '请选择',
                    validator: selectForNumberValidate,
                    required: true
                  }
                : {
                    message: '请选择',
                    validator: (rule, value) =>
                      arrayValueValidate(rule, value, {
                        warehouseId: item.warehouseId,
                        amount: item.amount
                      })
                  }
            "
          >
            <ParamCodesSelect
              :options="paramCodeData.fbu_demand_info"
              v-model:value="item.warehouseId"
              :view="formItemView"
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '海外仓月消费额（万元）'"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'demandInfo', 'warehouses', index, 'amount']"
            :rules="
              perfect
                ? {
                    message: '请输入',
                    required: true
                  }
                : {
                    message: '请输入',
                    validator: (rule, value) =>
                      arrayValueValidate(rule, value, {
                        warehouseId: item.warehouseId,
                        amount: item.amount
                      })
                  }
            "
          >
            <div class="flex">
              <CosInputNumber
                v-model:value="item.amount"
                :maxlength="15"
                :min="0"
                placeholder="请输入"
                :view="formItemView"
                style="width: 100%"
              />
              <a-button
                type="text"
                v-if="
                  form.business.demandInfo.warehouses && form.business.demandInfo.warehouses.length > 1 && !disabled
                "
                @click="handleDelCol(form.business.demandInfo.warehouses, index)"
                danger
                style="padding: 0 0 0 12px"
                >删除</a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="12" />
        </template>
      </MultipleItem>
    </dc-layout-card>
    <dc-layout-card title="ERP系统">
      <template #subTitle>
        <a-button type="primary" v-if="!disabled" ghost @click="handleAddCol(form.business.erpInfo)">新增</a-button>
      </template>
      <MultipleItem :view="formItemView" :line="false">
        <template v-for="(item, index) in form.business.erpInfo" :key="`erpInfo${index}`">
          <dc-form-item
            :label="index ? '' : 'ERP系统'"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'erpInfo', index, 'erpId']"
            :rules="
              perfect
                ? {
                    message: '请选择',
                    validator: selectForNumberValidate,
                    required: true
                  }
                : {
                    message: '请选择',
                    validator: (rule, value) =>
                      arrayValueValidate(rule, value, {
                        erpId: item.erpId,
                        erpAccount: item.erpAccount
                      })
                  }
            "
          >
            <ParamCodesSelect
              :options="paramCodeData.fbu_erp_info"
              v-model:value="form.business.erpInfo[index].erpId"
              :view="formItemView"
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '关联账号'"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'erpInfo', index, 'erpAccount']"
          >
            <div class="flex">
              <CosInput v-model:value="item.erpAccount" :view="formItemView" :maxlength="50" placeholder="请输入" />
              <a-button
                type="text"
                v-if="form.business.erpInfo && form.business.erpInfo.length > 1 && !disabled"
                @click="handleDelCol(form.business.erpInfo, index)"
                danger
                style="padding: 0 0 0 12px"
                >删除</a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="12" />
        </template>
      </MultipleItem>
    </dc-layout-card>
    <dc-layout-card title="补货方式">
      <template #subTitle>
        <a-button type="primary" v-if="!disabled" @click="handleAddCol(form.business.replenish)" ghost>新增</a-button>
      </template>
      <MultipleItem :view="formItemView" :line="false">
        <template v-for="(item, index) in form.business.replenish" :key="`replenish${index}`">
          <dc-form-item
            :label="index ? '' : '头程补货方式'"
            :span="6"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'replenish', index, 'replenishId']"
            :rules="{
              message: '请选择',
              validator: (rule, value) =>
                arrayValueValidate(rule, value, {
                  replenishId: item.replenishId,
                  frequency: item.frequency,
                  replenishment: item.replenishment
                })
            }"
          >
            <ParamCodesSelect
              :options="paramCodeData.fbu_head_replenish_method"
              v-model:value="item.replenishId"
              :view="formItemView"
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '补货频次'"
            :span="6"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'replenish', index, 'frequency']"
            :rules="{
              message: '请选择',
              validator: (rule, value) =>
                arrayValueValidate(rule, value, {
                  replenishId: item.replenishId,
                  frequency: item.frequency,
                  replenishment: item.replenishment
                })
            }"
          >
            <ParamCodesSelect
              :options="paramCodeData.fbu_replenish_frequency"
              v-model:value="item.frequency"
              :view="formItemView"
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '补货量(kg/m³)'"
            :span="6"
            :class="[index ? 'no-form-label' : '']"
            :name="['business', 'replenish', index, 'replenishment']"
            :rules="{
              message: '请输入',
              validator: (rule, value) =>
                arrayValueValidate(rule, value, {
                  replenishId: item.replenishId,
                  frequency: item.frequency,
                  replenishment: item.replenishment
                })
            }"
          >
            <div class="flex">
              <CosInput v-model:value="item.replenishment" :view="formItemView" placeholder="请输入" />
              <a-button
                type="text"
                @click="handleDelCol(form.business.replenish, index)"
                v-if="form.business.replenish && form.business.replenish.length > 1 && !disabled"
                danger
                style="padding: 0 0 0 12px"
                >删除</a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="6" />
        </template>
      </MultipleItem>
    </dc-layout-card>
  </a-form>
  <cos-footer-button
    v-if="!disabled"
    v-model:value="form"
    :resetValue="resetValue"
    :formRef="formRef"
    :loading="loading"
    @submit="handleSubmit"
    :disabled="disabled"
    :permissionPage="permissionPage"
  >
  </cos-footer-button>
</template>
<script setup lang="ts">
import { computed, nextTick, onMounted, watch, ref, PropType, reactive } from 'vue'
import type { Rule } from 'ant-design-vue/es/form'
import CustomerArea from '@/components/CustomerArea/index'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import SerialSelect from './serialSelect.vue'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import {
  customerGradeEnum,
  potentialStatusEnum,
  contractStatusEnum,
  clientsStatusEnum,
  customerTypeEnum,
  flagEnum,
  contactTypeEnum,
  linkRoleTypeEnum,
  genderEnum
} from '@/views/gucangSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { potentialAdd, potentialEdit } from '@/api/gucangSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { DcConfirm, message } from '@dc-platform/dc-components'
import { useRoute } from 'vue-router'
import { goBack } from '@/hooks/cosRouter'
import { usePermissionStore } from '@/stores/permission'
import { contactValidate, concatNameValidate, arrayValueValidate, selectForNumberValidate } from '@/utils/validate'
import { cloneDeep } from 'lodash-es'
import calc from '@/utils/calc'
import { initObjectVal, paramCodesDataFilter } from '@/utils/index'
import MapModal from '@/components/MapModal/index.vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'

import {
  checkAddressValidate,
  checkAddressData,
  handleAddressAdd,
  handleAddressAddDel
} from '@/hooks/addressArrValidate'
import CosInputTianyancha from '@/components/Antd/CosInputTianyancha/index.vue'
import { businessStatusEnum } from '@/views/yuntuSales/commonEnum/dataConfig'

const permissionStore = usePermissionStore()
const permissionBtn = ref<any[]>(permissionStore.permission)
const route = useRoute()
const initForm = reactive<any>({
  business: {
    businessType: [],
    saleInfo: [{}],
    demandInfo: {
      warehouses: [{}]
    },
    erpInfo: [{}],
    replenish: [{}]
  },
  contact: {},
  customerInfo: {},
  visitAddress: [{}]
})
const resetValue = ref(cloneDeep(initForm))
const loading = ref(false)
const form = ref<any>(cloneDeep(initForm))
const props = defineProps({
  disabled: {
    type: Boolean,
    default: true
  },
  data: {
    type: Object as PropType<PotentialItem>,
    default: () => {
      return {
        business: {},
        contact: {}
      }
    }
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  formItemView: {
    type: Boolean
  },
  type: {
    type: String,
    default: 'potential' // 潜在，contract 签约，clients 成交的基本信息
  },
  perfect: {
    type: Boolean,
    default: false
  },
  hideOk: {
    type: Boolean
  }
})
watch(
  () => props.data,
  (v, prev) => {
    if (v) {
      const formVal = v
      initObjectVal(formVal, initForm)
      form.value = cloneDeep(formVal)
      resetValue.value = cloneDeep(formVal)
    }
  },
  { immediate: true }
)
const formRef = ref()
const status = computed(() => {
  // 如果是签约客户编辑，不能选择终止合作
  if (route.path.includes('/fbu/contract/edit')) {
    return cloneDeep(contractStatusEnum).map((item: any) => {
      if (item.value === 22) {
        item.disabled = true
      }
      return item
    })
  }
  if (props.type === 'potential') {
    /// 归档状态不允许选择
    return potentialStatusEnum.map((item) => ({ ...item, disabled: item.value === 14 }))
  } else if (props.type === 'contract') {
    return contractStatusEnum
  } else if (props.type === 'clients') {
    return clientsStatusEnum
  }
  return []
})
/// 文本识别
const clipParseInfo = (parseInfo: any) => {
  if (!parseInfo) {
    return
  }
  let allBlank = false
  if (!form.value.contact.name && !form.value.customerAddress && !form.value.contact.mobile && !form.value.remark) {
    allBlank = true
  }
  if (allBlank) {
    form.value.contact.name = parseInfo.contactName
    form.value.customerAddress = parseInfo.address
    form.value.contact.mobile = parseInfo.phoneNum
    form.value.remark = parseInfo.detail
    return
  }
  DcConfirm.warning({
    title: '操作提示！',
    content: '是否替换原内容',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      form.value.contact.name = parseInfo.contactName
      form.value.customerAddress = parseInfo.address
      form.value.contact.mobile = parseInfo.phoneNum
      form.value.remark = parseInfo.detail
    }
  })
}
const paramCodeData = ref<any>({
  fbu_sales_category: [], // 销售品类
  fbu_product_type: [], // 货物类型
  fbu_warehouse: [], // 合作海外仓
  fbu_sale_platform: [], // 在售电商平台
  fbu_service_demand: [], // 服务需求
  fbu_demand_info: [], // 需求海外仓
  fbu_erp_info: [], // 目前使用ERP
  fbu_replenish_frequency: [], // 头程补货频次
  fbu_business_type: [], // 客户业务类型
  fbu_marketing_activity: [], // 关联市场活动
  fbu_head_replenish_method: [], // 头程补货方式
  fbu_area_code: [], // 电话区号
  fbu_customer_size: [], // 客户规模
  fbu_industrial_belt: [], // 产业带
  fbu_customer_category: []// 客户类别
})
const percentValidate = async (rule: Rule, value: string) => {
  const result = form.value.business.saleInfo.reduce(
    (prev: number, curr: any) => calc.Add(prev, Number(curr.percent) || 0),
    0
  )
  if (value && result !== 100) {
    return Promise.reject(new Error('在售平台占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}
const clearMainAddressFlag = (index: number) => {
  if (form.value.visitAddress) {
    for (const [i, item] of form.value.visitAddress.entries()) {
      if (index === i) {
        item.mainAddressFlag = item.mainAddressFlag === 1 ? 0 : 1
      } else {
        item.mainAddressFlag = 0
      }
    }
  }
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: [
      'fbu_sales_category',
      'fbu_product_type',
      'fbu_warehouse',
      'fbu_sale_platform',
      'fbu_service_demand',
      'fbu_demand_info',
      'fbu_erp_info',
      'fbu_replenish_frequency',
      'fbu_business_type',
      'fbu_marketing_activity',
      'fbu_head_replenish_method',
      'fbu_area_code',
      'fbu_customer_size',
      'fbu_sign_in_address_label',
      'fbu_industrial_belt',
      'fbu_customer_category'
    ]
  }).then((res) => {
    if (res.code === 200) {
      if (!props.disabled) {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
      }
      paramCodeData.value = res.data
    }
  })
}
onMounted(() => {
  getByParamCodes()
})
// 海外仓月销售额
const amount = computed(() => {
  const result = form.value.business.demandInfo.warehouses.reduce(
    (prev: number, curr: any) => calc.Add(prev, Number(curr.amount) || 0),
    0
  )
  return result || 0
})
// 去除数组null ''
const clear = (arr: any[], keys: string[]) => {
  if (!arr) {
    return []
  }
  let result: any = []
  arr.forEach((v: any) => {
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i]
      if (v[k] != null && v[k] !== '') {
        result.push(v)
        break
      }
    }
  })
  if (!result.length) {
    result = [{}]
  }
  return result
}
const changeIndustrialBeltFlag = () => {
  const { industrialBeltFlag } = form.value.business
  if (industrialBeltFlag === 0) {
    form.value.business.industrialBelt = -9
    form.value.business.industrialBeltLabel = ''
    form.value.business.industrialBeltName = ''
  }
}
const changeIndustrialBeltLabel = () => {
  nextTick(() => {
    const { industrialBeltLabel } = form.value.business
    if (industrialBeltLabel !== '其他') {
      form.value.business.industrialBeltName = ''
    }
  })
}
const handleSubmit = async () => {
  loading.value = true
  const p = cloneDeep(form.value)
  const { replenish, erpInfo, demandInfo, saleInfo } = p.business
  // 地址为空清除、判断地址是否重复
  if (checkAddressData(form.value.visitAddress)) {
    message.error('签到地址不可重复！')
    loading.value = false
    return false
  }
  const { visitAddress } = p
  p.visitAddress = clear(visitAddress, ['addressName'])
  // 新增、编辑的格式和详情不同、多传attrList
  if (JSON.stringify(p.visitAddress) === '[{}]') {
    p.visitAddress = { attrList: [] }
  } else {
    p.visitAddress = { attrList: p.visitAddress }
  }
  if (p.business) {
    p.business.replenish = clear(replenish, ['replenishId', 'frequency', 'replenishment'])
    p.business.erpInfo = clear(erpInfo, ['erpId', 'erpAccount'])
    p.business.saleInfo = clear(saleInfo, ['salePlatformId', 'percent'])
    if (demandInfo && demandInfo.warehouses) {
      p.business.demandInfo.warehouses = clear(demandInfo.warehouses, ['warehouseId', 'amount'])
    }
  }
  try {
    if (route.query.cosId) {
      await potentialEdit(p)
      message.success('编辑成功')
    } else {
      await potentialAdd(p)
      message.success('新增成功')
    }
    goBack()
  } catch (error) {}
  loading.value = false
}

// 新增列
const handleAddCol = (arr: {}[]) => {
  arr.push({})
}
// 删除列
const handleDelCol = (arr: {}[], index: number) => {
  arr.splice(index, 1)
}
</script>
<script lang="ts">
export default { name: 'customerCenterBaseMessage' }
</script>
